// Copyright (c) 2022 by Move Closer

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedAddon {
  AdditionalTitles = 'additionalTitles',
  Author = 'author',
  Categories = 'categories',
  Cover = 'cover',
  CustomSets = 'customList',
  Delayed = 'delayed',
  Layout = 'layout',
  Lead = 'lead',
  Meta = 'meta',
  RelatedArticles = 'relatedArticles',
  Tags = 'tags'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 *
 * Note! Body should be first element due to it is a default value & we want it to be displayed a top.
 */
export enum AllowedColor {
  Body = 'body',
  Black = 'black',
  Primary = 'primary',
  White = 'white',
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedContentType {
  Article = 'article',
  Page = 'page',
  Product = 'product',
  ProductCategory = 'product-category',
  Snippet = 'snippet'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedHAlignment {
  Center = 'center',
  Justify = 'justify',
  Left = 'left',
  Right = 'right'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedVAlignment {
  Bottom = 'bottom',
  Center = 'center',
  Stretch = 'stretch',
  Top = 'top'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedThemeSchema {
  Default = 'default',
  U20 = 'u20'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const CategoryDictionaryKey: string = 'articleCategories'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedStructureBreakpoint {
  XS = 'xs',
  LG = 'lg'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedStructureSlot {
  Bottom = 'bottom',
  Main = 'main',
  Right = 'right',
  Top = 'top'
}
